import { OTHER_CHURN_REASON } from "constants/churnDetails";
import { object, string } from "yup";

const requiredString = (message: string) =>
  string().when("request_spoc_to_fill", {
    is: false,
    then: (schema) => schema.required(message),
    otherwise: (schema) => schema.notRequired(),
  });

// Company Details fields (customer_name, spoc_name, joining_date,
// total_revenue_contribution, products_subscribed, filings_status) are
// auto-filled and never user-editable, so they stay optional -- a test
// account missing that data must still be submittable. company_dissolved is
// user-editable (unlike the rest of that section) so it's required like the
// other Churn Details fields. other_notes is the one explicit exception.
export const churnDetailsSchema = object({
  company_dissolved: requiredString("Company dissolved is required"),
  churn_reason: requiredString("Primary reason for churn is required"),
  save_attempt_performed: requiredString("Save attempt performed is required"),
  escalations_involved: requiredString("Escalations involved is required"),
  save_probability: requiredString("Save probability is required"),
  csm_score: requiredString("CSM's score is required"),
  considered_churn: requiredString("Considered churn is required"),
  other_reason_detail: string().when(["request_spoc_to_fill", "churn_reason"], {
    is: (requestSpocToFill: boolean, churnReason: string) =>
      !requestSpocToFill && churnReason === OTHER_CHURN_REASON,
    then: (schema) => schema.required("Please specify the reason"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
